import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {ISubscriptionPlanResponse} from '../../shared/models/i-subscription-plan-response';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionPlanService {
  subscriptionPlansSubject: BehaviorSubject<ISubscriptionPlanResponse[]> = new BehaviorSubject<ISubscriptionPlanResponse[]>([]);
  subscriptionPlans$: Observable<ISubscriptionPlanResponse[]> = this.subscriptionPlansSubject.asObservable();

  checkoutPlanSubject: BehaviorSubject<ISubscriptionPlanResponse | null> = new BehaviorSubject<ISubscriptionPlanResponse | null>(null);
  checkoutPlan$: Observable<ISubscriptionPlanResponse | null> = this.checkoutPlanSubject.asObservable();

  setPlans(plans: ISubscriptionPlanResponse[]): void {
    this.subscriptionPlansSubject.next(plans);
  }

  setCheckoutPlan(plan: ISubscriptionPlanResponse): void {
    this.checkoutPlanSubject.next(plan);
  }
}
